/* import __COLOCATED_TEMPLATE__ from './tile-content.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { BANKING_HOME_PAGE_PLACEMENT_ID } from '@banking/api/services/message-service-api';
import { Action, SPOSTileFormat } from '@square/dashboard-protos/models/squareup/messageservice/service';
let BankingTileContent = (_dec = computed('args.flatBottom'), _dec2 = computed('args.{index,current}'), _dec3 = computed('args.message.{sposTileFormat,tileFormat}'), _dec4 = computed('tile.imageUrl'), _dec5 = computed('imageUrl'), _class = class BankingTileContent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "messageServiceApi", _descriptor, this);
  }
  get flatBottom() {
    return Boolean(this.args.flatBottom);
  }
  get visible() {
    if (this.args.index === undefined || this.args.current === undefined) {
      return false;
    }
    return this.args.index === this.args.current;
  }
  trackEngagement(message, action) {
    this.messageServiceApi.trackEngagement(BANKING_HOME_PAGE_PLACEMENT_ID, message.requestToken, action);
  }
  handleTileClick() {
    this.trackEngagement(this.args.message, Action.CLICK);

    // TODO: refactor if there are more actions in the future
    // currently just use clientAction for viewInstantPayoutsDds and fallback to linkUrl for other scenarios
    if (this.tile?.clientAction?.viewInstantPayoutsDds && this.args.viewInstantPayoutsDds) {
      this.args.viewInstantPayoutsDds();
    } else if (this.tile?.linkUrl) {
      window.open(this.tile.linkUrl, '_blank', 'noopener noreferrer');
    }
  }
  get tile() {
    if (this.args.message?.tileFormat != null) {
      return this.args.message?.tileFormat;
    } else if (this.args.message?.sposTileFormat != null) {
      return this.args.message?.sposTileFormat;
    } else {
      return undefined;
    }
  }
  get imageUrl() {
    if (this.tile instanceof SPOSTileFormat) {
      return this.tile?.imageUrl;
    } else {
      return undefined;
    }
  }
  get showImage() {
    return Boolean(this.imageUrl);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "messageServiceApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "flatBottom", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "flatBottom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visible", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "visible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTileClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTileClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tile", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "tile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showImage", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "showImage"), _class.prototype), _class);
export { BankingTileContent as default };